export default __webpack_public_path__ + "static/IBMPlexSans-Thin-Latin1-9b1dc9b1729b4e7c27efb925b7b6b1ed.woff2";